/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-08-16 11:29:00
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-16 17:39:30
 * @FilePath: /chaoyongtuan/src/views/teamManage/roleManage/components/addMemberDraw/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

const username = {
	key: 'nickname',
	label: '用户名称',
	type: ColumnTypes.TextCell,
	minWidth: '150',
	headerAlign: 'left',
	maxShowLength: 6,
};

const mobile = {
	key: 'mobile',
	label: '手机号',
	type: ColumnTypes.TextCell,
	minWidth: '140',
	headerAlign: 'left',
};
const wechatInfo = {
	key: 'wechatInfo',
	label: '绑定微信',
	type: () => import('@/views/teamManage/accountManage/components/tableCells/deliveryCell.vue'),
	minWidth: '180',
	headerAlign: 'left',
	maxShowLength: 5,
};
const deptName = {
	key: 'deptName',
	label: '部门',
	type: ColumnTypes.TextCell,
	minWidth: '110',
	headerAlign: 'left',
	maxShowLength: 6,
};

export const columns = [username, mobile, wechatInfo, deptName];
